<template>
<div class="empty-block">
  <img src="@/assets/img/base/empty.png" :style="{width:imgWidth}">
  <div>{{ info }}</div>
</div>
</template>

<script>
export default {
  name: "Empty",
  props:{
    info:'',
    imgWidth:{
      default:'100px'
    }
  },
}
</script>

<style scoped>
.empty-block{
  margin: auto;
  text-align: center;
}
.empty-block img{
  object-fit: contain;
}
.empty-block div{
  font-size: 12px;
  margin-top: -20px;
  color: #8F8F8F;
}

</style>
